import {BaseService} from './BaseService';
import decode from 'jwt-decode';
export default class IncubationService extends BaseService {
  getProfile() {
      return decode(this.getToken());
  }

  getProject(id) {
    const url = new URL(`${this.domain}/project`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getProjectList() {
    const url = new URL(`${this.domain}/project/list`);
    url.search = new URLSearchParams()
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getGanttData(id) {
    const url = new URL(`${this.domain}/project/gantt`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getIncubationProject(id, state) {
    const url = new URL(`${this.domain}/project/incubation`);
    const params = { id, state };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  saveTask(tarea, id) {
      var currentUser = this.getProfile();
      const proyecto = {'tarea': tarea, 'id': id, 'createdby': currentUser.username};
      return this.fetch(`${this.domain}/project/task`, {
          method: 'POST',
          body: JSON.stringify({
            proyecto,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  deleteTask(idtarea, idproyecto) {
      const proyecto = {'idtarea': idtarea, 'idproyecto': idproyecto};
      return this.fetch(`${this.domain}/project/task`, {
          method: 'DELETE',
          body: JSON.stringify({
            proyecto,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  uploadTaskFile(archivo, tareaid) {
    const data = new FormData();
    data.append('file', archivo.file);
    data.append('name', archivo.name);
    data.append('description', archivo.description);
    data.append('tareaid', tareaid);

    return fetch(`${this.domain}/project/task/file`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: data,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }

  setInitialTasks(id) {
      const proyecto = {'id': id};
      return this.fetch(`${this.domain}/project/set-initial-tasks`, {
          method: 'POST',
          body: JSON.stringify({
            proyecto,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  editProject(proyecto) {
      return this.fetch(`${this.domain}/project`, {
          method: 'PUT',
          body: JSON.stringify({
            proyecto,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/ProyectService.js